import React from 'react';
import './about.css';

function About() {
  return (
    <div className="about-container">
      <h1 className="about-title">Hakkımızda</h1>
      
      <div className="about-content">
<div>
<div>
  
  <p>
    Temelleri <strong>1998</strong> yılında Sayın <strong>Yusuf Çetin</strong> tarafından atılan firmamız, 
    çelik konstrüksiyon ve dekorasyon alanında başladığı yolculuğunu, <strong>2013</strong> yılında  
    <strong> ERYA-ÇELİK</strong> markasıyla kurumsallaştırarak daha da ileriye taşımıştır. Bugün, 27 yılı aşkın tecrübesiyle 
    hem yurt içinde hem de yurt dışında sayısız projeye imza atan, güvenilir ve dinamik bir aile şirketi olarak 
    faaliyet göstermekteyiz.
  </p>

  <p>
    Kurulduğumuz günden bu yana, kaliteyi ve özgünlüğü ön planda tutarak, müşterilerimize özel çözümler 
    sunmayı ilke edindik. Her biri alanında uzman kadromuzla, projelerin her aşamasında titizlikle çalışıyor; 
    estetik, dayanıklılık ve işlevselliği bir araya getiriyoruz.
  </p>

  <section style={{ marginTop: '40px' }}>
    <h2>Hizmet Alanlarımız</h2>

    <p>
      ERYA-GROUP çatısı altında sunduğumuz hizmetler, geniş bir yelpazeye yayılmaktadır:
    </p>

    <ul>
      <li><strong>Çelik Konstrüksiyon Uygulamaları:</strong> Endüstriyel yapılardan mimari projelere kadar, yüksek dayanıklılık ve mühendislik hassasiyetiyle üretim.</li>
      <li><strong>Dekorasyon Uygulamaları:</strong> İç ve dış mekanlarda estetik çözümler, özgün tasarımlar ve kaliteli malzeme kullanımı.</li>
      <li><strong>Dizi ve Film Setleri:</strong> Sanat yönetmenleriyle iş birliği içinde, yaratıcı ve fonksiyonel set tasarımları.</li>
      <li><strong>Sinema ve Tiyatro Salonları:</strong> Akustik, görsellik ve konforu bir araya getiren özel mekanlar.</li>
      <li><strong>Özel Tasarım Metal Projeleri:</strong> Kişiye ve projeye özel, estetik ve teknik açıdan üstün metal işçiliği.</li>
      <li><strong>Otel ve Restoran Uygulamaları:</strong> Konsept tasarımlardan uygulamaya kadar, misafir deneyimini artıran çözümler.</li>
    </ul>
  </section>

  <section style={{ marginTop: '40px' }}>
    <h2>Vizyonumuz</h2>

    <p>
      ERYA-GROUP olarak vizyonumuz; sağlam temellere dayanan, yenilikçi ve sürdürülebilir projeler üretmek; 
      sektördeki gelişmeleri yakından takip ederek, müşterilerimize en yüksek standartlarda hizmet sunmaktır. 
      İnternet ortamında da güvenli, hızlı ve şeffaf bir hizmet anlayışıyla hareket ediyor; dijitalleşen dünyada da 
      varlığımızı güçlü bir şekilde sürdürüyoruz.
    </p>

    <p>
      Her projede, sadece bir yapı değil; bir değer, bir iz bırakmayı hedefliyoruz. Çünkü biz, işimizi sadece üretmek 
      değil, aynı zamanda yaşatmak olarak görüyoruz.
    </p>
  </section>
</div>


</div>
</div>



      {/* Founder Section */}
<div className="founder-section">
  <div className="founder-wrapper">
    <img
      src="/assets/resimler/YusufCetin2.jpg"
      alt="Yusuf Çetin"
      className="founder-photo"
    />
    <div className="founder-bio">
  <p className="founder-name">
    Yusuf Çetin<br />
    <span>Kurucu ve Yönetim Kurulu Başkanı</span>
  </p>

  <p className="founder-story">
    1974 yılında doğan Yusuf Çetin, 1986 yılında çırak olarak başladığı meslek hayatında 
    usta-çırak ilişkisiyle yetişmiş ve yıllar içinde kazandığı deneyimle kendi alanında alaylı bir zanaatkâr olmuştur.
  </p>
  <p className="founder-story">
    1998 yılında İstanbul’da kendi firmasını kurarak iş hayatına adım atan Çetin; 
    İstanbul, Samsun, Trabzon, Antalya, Adana, İzmir gibi birçok şehirde ve 
    Fas, Suudi Arabistan, Londra gibi yurt dışı projelerde proje ve imalat sorumlusu olarak görev almıştır.
  </p>

  <p className="founder-story">
    Bugün, yılların birikimiyle <strong>ERYA-GROUP</strong> çatısı altında, <strong>ERYA-MİMARİ</strong>,  <strong>ERYA-ÇELİK </strong>, <strong>ERYA-DEKORASYON</strong> olarak çalışmalarına aktif olarak devam etmekte 
    ve birçok önemli projeye imzasını atmayı sürdürmektedir.
  </p>
</div>

  </div>
</div>



      <div className="team-section">
        <h2>Ekibimiz</h2>
        <table className="team-table">
          <tbody>
            <tr>
              <td>Tülay Çetin</td>
              <td>Finans Müdürü</td>
            </tr>
            <tr>
              <td>Yaren Ç. Guliyev</td>
              <td>Satın Alma Müdürü</td>
            </tr>
             <tr>
              <td>S. Eren Çetin</td>
              <td>iç Mimar</td>
            </tr>
            <tr>
              <td>Esra Çalışkan</td>
              <td>İç Mimar</td>
            </tr>
        
            <tr>
              <td>Ahmet Aksu</td>
              <td>Usta Başı</td>
            </tr> 
              <tr>
              <td>Haydar Guliyev</td>
              <td>Teknik Usta</td>
            </tr>
            <tr>
              <td>Mustafa Ozan</td>
              <td>Usta</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default About;
